/**
 * Бюджет хода героя в локальной секе — держим в одном месте с сервером (`SEKA_TURN_BUDGET_MS`, по умолчанию 30 с).
 * CRA: переопределение через `REACT_APP_SEKA_TURN_BUDGET_MS`.
 */

const envRaw =
  typeof process !== 'undefined' && process.env && process.env.REACT_APP_SEKA_TURN_BUDGET_MS
    ? Number(process.env.REACT_APP_SEKA_TURN_BUDGET_MS)
    : NaN;

const ms = Number.isFinite(envRaw) && envRaw >= 5000 ? envRaw : 30_000;

/** Бюджет хода (мс), как на сервере после `SEKA_TURN_BUDGET_MS`. */
export const SEKA_HERO_TURN_BUDGET_MS = ms;

/** Секунды для UI-таймера (потолок от миллисекунд). */
export const SEKA_HERO_TURN_SECONDS_CEIL = Math.max(1, Math.ceil(SEKA_HERO_TURN_BUDGET_MS / 1000));
